import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBusinessInfo } from '../lib/businessInfo';

const LOGO = 'https://customer-assets.emergentagent.com/job_buraq-transport/artifacts/0a9wh5vw_0E081036-6309-4011-9127-0A9FE497D0F8.png';
const DESK = { label: '+1 (929) 560-6305', href: 'tel:+19295606305' };
const link = 'inline-flex items-center min-h-[44px] px-1 text-gray-300 hover:text-orange-400 focus-visible:text-orange-400 focus-visible:outline-none transition-colors';

// The /book-preview footer: a thin orange gradient line across the page, the links in a row, the small logo and the copyright line.
export default function PreviewFooter() {
  const navigate = useNavigate();
  const biz = useBusinessInfo();
  const go = (path) => () => { navigate(path); if (typeof window !== 'undefined' && window.scrollTo) window.scrollTo(0, 0); };
  return (
    <footer className="relative mt-4 pb-10" data-testid="preview-footer">
      <div className="h-px w-full" aria-hidden="true" data-testid="footer-line" style={{ background: 'linear-gradient(90deg, rgba(249,115,22,0) 0%, #F97316 50%, rgba(249,115,22,0) 100%)' }} />
      <nav aria-label="Footer" className="flex flex-wrap items-center justify-center gap-x-5 sm:gap-x-8 gap-y-1 pt-6 text-base">
        <a href={DESK.href} className={link} data-testid="footer-concierge" aria-label={`Concierge: call ${DESK.label}`}>Concierge</a>
        <button type="button" onClick={go('/')} className={link} data-testid="footer-fleet">Fleet</button>
        <button type="button" onClick={go('/contact')} className={link} data-testid="footer-contact">Contact</button>
        <button type="button" onClick={go('/terms')} className={link} data-testid="footer-terms">Terms</button>
        <button type="button" onClick={go('/privacy')} className={link} data-testid="footer-privacy">Privacy</button>
      </nav>
      <div className="flex flex-col items-center gap-3 pt-5">
        <img src={LOGO} alt="RideBuraq" className="w-8 h-8 object-contain" />
        <p className="text-sm text-gray-300 text-center" data-testid="footer-copy">© 2026 {biz.brand} · New York</p>
      </div>
    </footer>
  );
}
